import React, { useState, useEffect, useRef } from "react";
import Modal from '@/react/libraries/Modal';

const FilterItem = (
	{
		title,
		filters = ["__ __"],
		separator = "\n"
	}
) => {
	// if (!filters) return null
	return (
		<div>
			<h2 className='font-medium text-grey-text'>
				{title}
			</h2>
			{/* filters is an array */}
			<div className='text-sm'>
				{filters.join(separator)}
			</div>
		</div>
	)
}

const FilterList = ({ filters, modalTriggerRef }) => {
	const modalRef = useRef(null)

	return (
		<Modal ref={modalRef} modalTriggerRef={modalTriggerRef} className={`modal__content-wrapper p-2 `}>
			<div className="modal__content-wrapper-header">
				<h2>Applied filters</h2>
			</div>
			<div class="modal__content-wrapper-body">
				<div
					class="grid grid-cols-[1fr,0.75fr] grid-rows-[repeat(4,auto)] grid-flow-col gap-y-5 gap-x-20 max-h-[60%] max-w-[800px] overflow-y-auto [&>div]:flex [&>div]:flex-col [&>div]:gap-5">
					<div id="country">
						<FilterItem title='Country' filters={filters?.country} separator=", " />
					</div>
					<div id="state">
						<FilterItem title='State' filters={filters?.state} separator=', ' />
					</div>
					<div id="category">
						<FilterItem title='Category' filters={filters?.category} />
					</div>
					<div id="sub_category">
						<FilterItem title='Subcategory' filters={filters?.sub_category} />
					</div>
					<div id="record_type">
						<FilterItem title='Record Type' filters={filters?.record_type} />
					</div>
					<div id="keyword">
						<FilterItem title='Keyword' filters={filters?.keyword} />
					</div>
					<div id="number">
						<FilterItem title='Number' filters={filters?.number} />
					</div>
				</div>
			</div>
			<div className="modal__content-wrapper-footer">
				<button className='btn btn-outline-primary' onClick={modalRef.current?.closeModal}>Go back</button>
			</div>
		</Modal>
	)
}

export default FilterList